import { isBanamexTenant } from "./banamex";

/**
 * Varios registros de sancion o compensacion por involucrado, para que distintos
 * equipos actuen a su ritmo y cada registro genere su propio caso de Workday.
 *
 * Solo Banamex: el Excel de sanciones junta los registros de una persona
 * unicamente para sus schemas (djaguar, Exports/excel/sanctions.py). En otro
 * tenant la fila conservaria solo el ultimo registro y el reporte quedaria corto.
 *
 * @returns {boolean} true si el tenant actual admite varios registros por persona
 */
export const isMultipleSanctionsEnabled = () => isBanamexTenant();
